// extracted by mini-css-extract-plugin
export default {"input":"CourseGroupInput_input__Uktq1"};